/* eslint camelcase: 0 */
import { Unread } from '@/infrastructure/network/Monitaro/schema/models'
import { IUnreadProps, EmptyUnreadPropsFactory } from '@/entities/Unread'

export const toUnreadProps = (props: Unread | null | undefined): IUnreadProps => {
  if (!props) {
    return EmptyUnreadPropsFactory()
  }

  const { total, talk, appointment, message, notice } = props

  return EmptyUnreadPropsFactory({
    total,
    talk,
    appointment,
    message,
    notice
  })
}
